/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { PhoneNumber } from '../models/PhoneNumber';
import type { Preferences } from '../models/Preferences';
import type { PreferencesNullable } from '../models/PreferencesNullable';
import type { SessionClosePolicy } from '../models/SessionClosePolicy';
import type { TagData } from '../models/TagData';
import type { UserEmail } from '../models/UserEmail';
import type { UserId } from '../models/UserId';
import type { UserName } from '../models/UserName';
import type { UserPassword } from '../models/UserPassword';
import type { UserRights } from '../models/UserRights';
import type { VehicleId } from '../models/VehicleId';
import type { VehicleSession } from '../models/VehicleSession';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class MeService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get my open vehicle session
     * Get my open vehicle session
     * @returns VehicleSession My open vehicle session
     * @throws ApiError
     */
    public vehicleSessionGet(): Observable<VehicleSession> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/me/vehicle_session',
            errors: {
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Open my vehicle session
     * Open my vehicle session
     * @param requestBody
     * @returns any The session
     * @throws ApiError
     */
    public vehicleSessionOpen(
        requestBody: {
            close_policy: SessionClosePolicy;
            tag: TagData;
        },
    ): Observable<(VehicleSession & {
        /**
         * Sessions closed by this sign-in
         */
        displaced: Array<{
            /**
             * Close reason
             */
            close_reason: 'displaced' | 'policy';
            /**
             * When it ended
             */
            ended_at: string;
            /**
             * The caller's own session
             */
            is_own_session: boolean;
            vehicle_id: VehicleId;
        }>;
    })> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/me/vehicle_session',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `Not found`,
                410: `Expired`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Close my vehicle session
     * Close my vehicle session
     * @returns void
     * @throws ApiError
     */
    public vehicleSessionClose(): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/me/vehicle_session',
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * List my API tokens
     * Get list of all my API tokens
     * @returns any OK
     * @throws ApiError
     */
    public listTokens(): Observable<Array<{
        /**
         * Token creation date
         */
        created_at: string;
        /**
         * Token expiry
         */
        expires_at: string;
        /**
         * Token ID
         */
        id: string;
        /**
         * Token name
         */
        name?: string | null;
        /**
         * Assigned right identifiers
         */
        rights: Array<string>;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/me/tokens/',
            errors: {
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Create API token
     * Create API token
     * @param requestBody
     * @returns any Token created
     * @throws ApiError
     */
    public createToken(
        requestBody: ({
            /**
             * Token expiry (up to 1 year from now)
             */
            expires: string;
            /**
             * Token name
             */
            name?: string | null;
        } & UserRights & {
            rights: Array<string>;
        }),
    ): Observable<({
        /**
         * Token expiry
         */
        expires_at: string;
        /**
         * Token ID
         */
        id: string;
        /**
         * Token name
         */
        name: string | null;
        /**
         * JWT token (save this, it will not be shown again)
         */
        token: string;
    } & UserRights & {
        rights: Array<string>;
    })> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/me/tokens/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Set my preferences
     * Set my preferences
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public preferencesSet(
        requestBody: Preferences,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/me/preferences',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Link Google account
     * Link my account to a Google identity
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public googleLink(
        requestBody: {
            /**
             * Google ID token issued by Google Identity Services
             */
            id_token: string;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/me/google-link',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                409: `Already linked`,
                500: `Server error`,
            },
        });
    }
    /**
     * Unlink Google account
     * Unlink Google account
     * @returns void
     * @throws ApiError
     */
    public googleUnlink(): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/me/google-link',
            errors: {
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get info about me
     * Get info about me
     * @returns any User info
     * @throws ApiError
     */
    public me(): Observable<(UserName & PhoneNumber & UserEmail & UserRights & PreferencesNullable & {
        id?: UserId;
        /**
         * External auth providers this account is linked to
         */
        linked_providers: Array<'google'>;
    } & {
        /**
         * First name
         */
        first_name: string | null;
        /**
         * Last name
         */
        last_name: string;
        /**
         * Phone number
         */
        phone_number: string | null;
        /**
         * Email address
         */
        email: string | null;
        rights: Array<string>;
        preferences: {
            /**
             * ID of hidden vehicles on the main map
             */
            hidden_vehicles?: Array<string>;
            /**
             * Show operators instead of vehicles on the main map
             */
            operators_on_map?: boolean;
            /**
             * Show operator "Last name | First name"
             */
            show_last_name_first?: boolean;
            /**
             * Station transactions default type
             */
            station_transactions?: 'in' | 'out' | null;
            vehicle_session_policy?: SessionClosePolicy;
        } | null;
        id: UserId;
    })> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/me/',
            errors: {
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit my details
     * Edit myself
     * @param requestBody
     * @returns any Logged out
     * @throws ApiError
     */
    public editMyself(
        requestBody: (UserName & PhoneNumber & UserPassword & UserEmail),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/me/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Revoke API token
     * Delete and revoke an API token
     * @param id Token ID
     * @returns void
     * @throws ApiError
     */
    public revokeToken(
        id: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/me/tokens/{id}/',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
